<pui-sub-header>
  <div class="d-flex w-100 justify-content-between align-items-center">
    <div>
      <button pui-button variant="secondary" (click)="onGoBack()"><pui-icon left icon="arrow-left" />Powrót</button>
    </div>
    <div>
      @if(editMode){
      Edytuj użytkownika
      } @else {
      Dodaj użytkownika
      }
    </div>
    <div class="d-flex gap-12">
      <button pui-button variant="primary" (click)="onSubmit()">
        @if(editMode){
        Zapisz
        } @else {
        Dodaj użytkownika
        }
      </button>
    </div>
  </div>
</pui-sub-header>

@if(isReady()){
<form class="page-container" [formGroup]="userForm">
  <pui-form-group [title]="'Dane osobowe'" [description]="'Wpisz podstawowe dane osoby'">
    <pui-form-row>
      <pui-form-field>
        <pui-label>Nazwa użytkownika</pui-label>
        <input puiInput type="text" placeholder="Wprowadź nazwę użytkownika" formControlName="username" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('username')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>

    <pui-form-row>
      <pui-form-field>
        <pui-label>Imię</pui-label>
        <input puiInput type="text" placeholder="Wprowadź imię" formControlName="firstName" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('firstName')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>

    <pui-form-row>
      <pui-form-field>
        <pui-label>Nazwisko</pui-label>
        <input puiInput type="text" placeholder="Wprowadź nazwisko" formControlName="lastName" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('lastName')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
  </pui-form-group>

  <pui-form-group [title]="'Administracja'" [description]="'Określ rodzaj i przeznaczenie konta'">

    <pui-form-row>
      <pui-form-field>
        <pui-label>Typ</pui-label>
        <pui-select [multiple]="false" formControlName="group">
          <pui-placeholder>Wybierz</pui-placeholder>
          @for(option of groups(); track $index){
          <pui-option [value]="option">{{option}}</pui-option>
          }
        </pui-select>
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('group')">
        </rqa-field-error>
      </pui-form-field>
      <pui-form-field>
        <pui-label>Rola</pui-label>
        <pui-select [multiple]="false" formControlName="role">
          <pui-placeholder>Wybierz</pui-placeholder>
          @for(option of roles(); track $index){
          <pui-option [value]="option">{{option}}</pui-option>
          }
        </pui-select>
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('role')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
    <pui-form-row>
      <pui-form-field>
        <pui-label>Jednostka odpowiedzialna</pui-label>
        <input puiInput type="text" placeholder="Wprowadź nazwę jednostki odpowiedzialnej"
          formControlName="responsibleUnit" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('responsibleUnit')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
  </pui-form-group>

  <pui-form-group [title]="'Dane kontaktowe'" [description]="'Podaj środki kontaktu wraz z organizacją zrzeszającą'">
    <pui-form-row>
      <pui-form-field>
        <pui-label>E-mail</pui-label>
        <input puiInput type="text" placeholder="Wprowadź e-mail" formControlName="email" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('email')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
    <pui-form-row>
      <pui-form-field>
        <pui-label>Organizacja</pui-label>
        <input puiInput type="text" placeholder="Wprowadź organizacje" formControlName="organization" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('organization')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
    <div formArrayName="phone">
      @for (phoneControl of phone.controls; track phoneControl; let i = $index) {
      <pui-form-row>
        <pui-form-field>
          <pui-label>Numer telefonu</pui-label>
          <input puiInput type="text" placeholder="Wprowadź numer telefonu" rqaPhoneNumber [formControlName]="i" />
          <rqa-field-error ngProjectAs="pui-form-field-error" [control]="phoneControl">
          </rqa-field-error>
          @if(phone.controls.length > 1){
          <button type="button" pui-button [variant]="'primary'" [destructive]="true"
            (click)="removePhone(i)">Usuń</button>
          }
        </pui-form-field>
      </pui-form-row>
      }
      <pui-form-row>
        <button type="button" pui-button style="width: 100%;" [variant]="'secondary'" (click)="addPhone()"
          [disabled]="phone.controls.length >= 5"><pui-icon left icon="plus" />Dodaj kolejny numer</button>
      </pui-form-row>
    </div>
  </pui-form-group>

  <pui-form-group [title]="'Dodatkowe'">
    <pui-form-row>
      <pui-form-field>
        <pui-label>Czas</pui-label>
        <pui-select [multiple]="false" formControlName="time">
          <pui-placeholder>Wybierz</pui-placeholder>
          @for(option of time(); track $index){
          <pui-option [value]="option">{{option}}</pui-option>
          }
        </pui-select>
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('time')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
    <pui-form-row>
      <pui-form-field>
        <pui-label>Język</pui-label>
        <pui-select [multiple]="false" formControlName="locale">
          <pui-placeholder>Wybierz</pui-placeholder>
          @for(option of locale(); track $index){
          <pui-option [value]="option">{{option}}</pui-option>
          }
        </pui-select>

        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('locale')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
    <pui-form-row>
      <pui-form-field>
        <pui-label>ASM2 Info</pui-label>
        <input puiInput type="text" placeholder="Wprowadź ASM2 Info" formControlName="observation" />
        <rqa-field-error ngProjectAs="pui-form-field-error" [control]="userForm.get('observation')">
        </rqa-field-error>
      </pui-form-field>
    </pui-form-row>
  </pui-form-group>
</form>
}